// Global packages and functions
import { useState, useEffect } from 'react'
import { useFetcher } from '@remix-run/react'
import { action } from '~/routes/api.autocomplete'

// Types
import type { BrendaHeaderSearchProduct } from '~/types'

// Main export
const useSearch = ({ query }: { query: string }) => {
  const fetcher = useFetcher<typeof action>()

  // Local states
  const [loading, setLoading] = useState<boolean>(false)
  const [suggestions, setSuggestions] = useState<{ suggest: string }[]>([])
  const [products, setProducts] = useState<BrendaHeaderSearchProduct[]>([])

  // Get suggested search terms
  const getSuggestions = (query: string) => {
    fetcher.submit(
      { query },
      {
        method: 'post',
        encType: 'application/json',
        action: '/api/autocomplete',
      }
    )
  }
  // Get suggested results when query value changes
  useEffect(() => {
    if (query) {
      const queryDelay = setTimeout(() => {
        getSuggestions(query)
      }, 500)

      return () => clearTimeout(queryDelay)
    } else {
      setSuggestions([])
      setProducts([])
    }
    // @NOTE: ONLY USE THE BELOW TO SURPRESS FETCHER WARNINGS
    // ..IF YOUR SURE THE FETCHER ISNT CHANGING BETWEEN RENDERS
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  // Run the suggested results function and populate our local state
  useEffect(() => {
    // Fetcher loading states
    if (fetcher?.state == 'submitting') {
      setLoading(true)
    }

    if (fetcher?.state == 'idle') {
      setLoading(false)
    }

    // Fetcher data
    if (fetcher?.state == 'loading' && fetcher?.data) {
      const results = fetcher?.data?.suggestions

      setSuggestions(
        results?.suggestionResults?.length &&
          results?.suggestionResults[0]?.suggestions?.length
          ? results?.suggestionResults[0].suggestions
          : []
      )

      setProducts(results?.productResults?.length ? results.productResults : [])
    }
  }, [fetcher])

  return {
    suggestions,
    products,
    loading,
  }
}

export default useSearch
